export const Types = {
    FETCH_USER_PROFILE: "FETCH_USER_PROFILE",
    RECEIVED_USER_PROFILE: "RECEIVED_USER_PROFILE",
    SAVE_PROFILE_ERROR: "SAVE_PROFILE_ERROR",
    SAVE_PROFILE_SUCCESS: "SAVE_PROFILE_SUCCESS",
    START_SAVE_PROFILE: "START_SAVE_PROFILE"
};

export const fetchUserProfileAction = id => ({
    type: Types.FETCH_USER_PROFILE,
    id
});

export const receivedUserProfileAction = profile => ({
    type: Types.RECEIVED_USER_PROFILE,
    profile
});

export const startSaveProfileAction = (data) => ({
    type: Types.START_SAVE_PROFILE,
    id: data.id,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    username: data.username
});

export const saveProfileSuccessAction = () => ({
  type: Types.SAVE_PROFILE_SUCCESS
});

export const saveProfileErrorAction = () => ({
  type: Types.SAVE_PROFILE_ERROR
});



// WEBPACK FOOTER //
// ./public/pages/Profile/actions.js